exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vcp-controls{z-index:10;position:absolute;left:0;bottom:5px;width:100%;height:50px;text-align:left}.playback-control,.setting-control{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;top:0;height:100%;text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.playback-control{left:0}.setting-control{right:0}", ""]);

// exports
